import styles from "./SocialIcons.module.scss";

import Facebook from "/packages/icons/social/facebook.svg";
import Instagram from "/packages/icons/social/instagram.svg";
import X from "/packages/icons/social/x.svg";
import Youtube from "/packages/icons/social/youtube.svg";
import { useSiteSettings } from '@/context/siteSettings'

const icons = {
  facebook: {
    icon: <Facebook />,
    label: "Visit our Facebook page",
  },
  instagram: {
    icon: <Instagram />,
    label: "Check out our Instagram",
  },
  x: {
    icon: <X />,
    label: "Follow us on 𝕏",
  },
  youtube: {
    icon: <Youtube />,
    label: "Watch our videos on YouTube",
  },
};

export default function SocialIcons({ tabIndex }) {
  const { social } = useSiteSettings() || {};

  if (!social) return null;

  return (
    <ul className={styles.social_links} aria-label="social media links">
      {Object.entries(social).map(([platform, url]) => {
        if (!icons[platform]) return null; // skip unknown icons

        return (
          <SocialIcon
            key={platform}
            title={platform}
            link={url}
            label={icons[platform].label}
            icon={icons[platform].icon}
            tabIndex={tabIndex}
          />
        );
      })}
    </ul>
  );
}

function SocialIcon({ title, link, label, icon, tabIndex }) {
  return (
    <li>
      <a
        href={link}
        aria-label={label}
        className={styles[title]}
        tabIndex={tabIndex}
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon}
      </a>
    </li>
  );
}
